const authority = import.meta.env.VITE_APP_BD_OIDC_IP;
const openidConnect = `${authority}/protocol/openid-connect`;

export const oidcSettings = {
  authority,
  metadata: {
    issuer: authority,
    authorization_endpoint: `${openidConnect}/auth`,
    token_endpoint: `${openidConnect}/token`,
    userinfo_endpoint: `${openidConnect}/userinfo`,
    end_session_endpoint: `${openidConnect}/logout`,
  },
  client_id: import.meta.env.VITE_APP_OIDC_RP_CLIENT_ID_FRONT,
  redirect_uri: `${window.location.origin}/oidc-callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  responseType: "code",
  scope: "openid profile email",
  //silentRedirectUri: `${window.location.origin}/silent-renew-oidc.html`,
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  monitorSession: false,
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 3 * 60,
};
